import ImageHelper from "./ImageHelper";

export default class Preview {
  constructor(props) {
    this.canvasId = props.id;
    this.canvas = document.getElementById(props.id);
    this.ctx = this.canvas.getContext('2d');
    this.ctx.imageSmoothingQuality = 'high';
    this.imageHelper = new ImageHelper();
    this.payload = null;
    this.oldPayload = null;
    this.isBagLabel = false;
    this.stickerLabelType = "";
    this.bagLabelFormPath = {
      "bag_configurator": new Path2D(
        "M 202.6189 23.3278 H 202.6189 A 181.6816 177.666 90 0 0 148.2693 1.4804 L 147.1683 1.251 A 15.0724 14.7392 90 0 0 144.7422 1.0423 A 15.5308 15.1875 90 0 0 129.5542 16.4687 V 16.678 A 28.2684 27.6435 90 0 1 129.2897 20.1588 A 25.4338 24.8711 90 0 1 79.9139 16.678 C 79.9139 16.5523 79.9139 16.4272 79.9139 16.3027 V 16.3027 A 15.427 15.0855 90 0 0 62.3412 1.251 L 61.2603 1.5012 A 180.9939 176.9931 90 0 0 6.9315 23.3278 A 11.8827 11.62 90 0 0 1.0192 33.3554 V 290.5244 A 11.8619 11.5999 90 0 0 6.9315 300.5934 A 185.2467 181.1522 90 0 0 76.8563 325.2132 A 211.2224 206.5534 90 0 0 104.7648 327.1317 A 213.9111 209.1834 90 0 0 132.6532 325.2132 A 185.6848 181.5802 90 0 0 202.6189 300.5519 A 11.9035 11.6408 90 0 0 208.5306 290.4829 V 33.3554 A 11.945 11.6811 90 0 0 202.6189 23.3278 Z"
      ),
      "key_configurator": new Path2D("M 173.8108 19.1826 H 173.8108 A 151.7564 147.5713 0 0 0 127.2293 1.3864 L 126.3064 1.1825 A 12.9556 12.5982 0 0 0 111.2758 13.5975 V 13.7397 A 23.4377 22.7911 0 0 1 111.108 16.5735 A 21.32 20.732 0 0 1 68.6566 13.6988 S 68.6566 13.4955 68.6566 13.3936 V 13.3936 A 12.9977 12.6391 0 0 0 55.6589 1.1617 A 10.964 10.6618 0 0 0 53.5625 1.3455 L 52.6189 1.5292 A 151.8406 147.6531 0 0 0 6.1002 19.1826 A 9.979 9.7033 0 0 0 1.0479 27.3372 V 236.9213 A 9.9161 9.6423 0 0 0 6.1216 245.0759 A 155.5089 151.2206 0 0 0 66.0356 265.2164 A 180.2886 175.3163 0 0 0 113.8541 265.2164 A 155.7187 151.4239 0 0 0 173.8108 245.1162 A 9.9369 9.663 0 0 0 178.8625 236.9622 V 27.3781 A 9.979 9.7033 0 0 0 173.8108 19.1826 Z"),
    };
  }

  generate(payload) {
    this.stickerLabelType = payload.props.model;
    if(payload.props.model === "bag_configurator" || payload.props.model === "key_configurator"){
      $("#sticker-preview-canvas").css("boxShadow", "none");
      this.isBagLabel = true;
    }
    if(payload.props.image) {
      let widthModified = false;
      let firstNameSize = null;
      let lastNameSize = null;

      this.canvas.width = payload.data.sizes.width;
      this.canvas.height = payload.data.sizes.height;

      if(payload.props.model === 'elongated') {
        let text = payload.data.full_name;
        let isYGJWords = text.indexOf('y') !== -1 || text.indexOf('g') !== -1 || text.indexOf('j') !== -1;
        if(payload.data.text_uppercase) {
          text = text.toUpperCase();
        }

        switch (payload.props.font_family) {
          case "Indie Flower":
            if(isYGJWords) payload.data.font_size = Math.min(25,payload.data.font_size);
            break;
          case "Fjalla One":
            payload.data.font_size = Math.min(26,payload.data.font_size);
            break;
          case "Lobster":
            payload.data.font_size = Math.min(26,payload.data.font_size);
            break;
          case "Cocogoose":
            payload.data.font_size = Math.min(26,payload.data.font_size);
            break;
          default:
            break;
        }
        this.ctx.font = `${payload.data.font_weight} ${payload.data.font_size}px ${payload.props.font_family}`;
        this.ctx.textAlign = payload.data.text_direction;
        this.ctx.textBaseline = "middle";

        let maxWidth = payload.data.text_sizes.width;
        let textWidth = this.ctx.measureText(text).width;

        if(maxWidth > textWidth) {
          widthModified = true;
          this.canvas.width = textWidth + (((14) * 3.7795275591)) * payload.data.scale;
          // payload.data.mm_sizes.width = this.canvas.width * 0.2645833333 / payload.data.scale;

          // if(payload.data.mm_sizes.width > 60) {
          //   payload.data.mm_sizes.width = 60;
          // }
        }
      }

      // this.addDecorSizes(payload.data.mm_sizes.width/10, payload.data.mm_sizes.height/10);
      this.changeModel(payload.props.model);

      this.addBg(payload.props.background, this.canvas.width, this.canvas.height).then(() => {
        let border = payload.props.hasOwnProperty('image_border') ? payload.props.image_border : null;

        if(widthModified) {
          payload.data.image_coordinates.x = this.canvas.width - (6 * 3.7795275591) * payload.data.scale;
          payload.data.text_sizes.width = this.canvas.width - (14.5 * 3.7795275591) * payload.data.scale;
        }

        this.addImage(payload.props.image, payload.data.image_sizes, payload.data.image_coordinates, border).then(() => {
          let leftDirectionModels = ['elongated'];

          payload.data.text_direction = "center";

          if(leftDirectionModels.includes(payload.props.model)) {
            payload.data.text_direction = "left";
          }

          if(payload.props.first_name && payload.props.last_name && payload.props.model === 'elongated') {
            firstNameSize = this.addText([payload.data.full_name], [this.parseTextSettings(payload)], 0);
            lastNameSize = firstNameSize;
          }else {

            if(payload.props.first_name && payload.props.last_name) {
              //need for compare text width and find the smallest
              window.configurator_first_name = payload.props.first_name;
              window.configurator_last_name = payload.props.last_name;

              let nameSizes = this.addText(
                [payload.props.first_name,payload.props.last_name],
                [this.parseTextSettings(payload, 'multiple',1),this.parseTextSettings(payload, 'multiple', 1)],
                1,
                ["first","last"],
                'multiple');
              firstNameSize = nameSizes[0];
              lastNameSize = nameSizes[1];
              // lastNameSize = this.addText(payload.props.last_name, this.parseTextSettings(payload, 'multiple', 1), 1, "last", 'multiple');

              window.configurator_first_name = null;
              window.configurator_last_name = null;
            }else {
              firstNameSize = this.addText(
                [payload.data.full_name],
                [this.parseTextSettings(payload)],
                0);
              lastNameSize = firstNameSize;
            }
          }

          // new code without canvas render label

          $('#sticker-preview-canvas').hide();
          $('#label_preview').html(`
                      <div style="display: flex; justify-content: center; align-items: center; width: 100px; height: 100px;">
                        <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
                      </div>
                    `);
          $('.line-x').html(`<div></div>`).hide();
          $('.line-y').html(`<div></div>`).hide();
          $('#sticker-preview span').attr('style', 'display:none !important');
          let model = null;
          if(payload.props.model === 'key_configurator') {
            model = 5;
          } else if(payload.props.model === 'bag_configurator'){
            model = 4;
          } else {
            model = $('#configurator_model').val()
          }
          function getWidth() {
            return Math.max(
              document.body.scrollWidth,
              document.documentElement.scrollWidth,
              document.body.offsetWidth,
              document.documentElement.offsetWidth,
              document.documentElement.clientWidth
            );
          }
          $.post("https://crm-luckylabels.best4utech.nl/api/test-server-side", {
            first_name: payload.props.first_name,
            last_name: payload.props.last_name,
            image: $('#configurator_image').val(),
            background: $('#configurator_background').val(),
            font: $('#configurator_fonts').val(),
            text_color: $('#configurator_text_color').val(),
            model
          })
            .done(function(data) {
              $('#label_preview').html(data);
              $(document).trigger('preview:generated', {
                model: payload.props.model,
                url: data,
                width: (payload.data.mm_sizes.width).toFixed(2),
                first_name_size: firstNameSize,
                last_name_size: lastNameSize,
              });
              // let lineX = Math.round((parseInt($('.labelBlock').css('width')) / 37.7933333333333) * 10) / 10;
              // let lineY = Math.round((parseInt($('.labelBlock').css('height')) / 37.7933333333333) * 10) / 10;
              let lineX = parseInt($('.labelBlock').css('width')) / 37.7933333333333;
              let lineY = parseInt($('.labelBlock').css('height')) / 37.7933333333333;
              $('.line-x').html(`<div class="size">${parseFloat(lineX.toFixed(1))} cm</div>`).show();
              $('.line-y').html(`<div class="size">${parseFloat(lineY.toFixed(1))} cm</div>`).show();
              $('#sticker-preview span').attr('style', 'display:block !important');
              if (getWidth() < 760) {
                 $('.owl-item .overlay').html(`<div class="d-flex justify-content-center align-items-center sticker-gallery-preview ${payload.props.model}">${data}</div>`);
              }
            });

          // $(document).trigger('preview:generated', {
          //   model: payload.props.model,
          //   url: this.getBase64(),
          //   width: (payload.data.mm_sizes.width).toFixed(2),
          //   first_name_size: firstNameSize,
          //   last_name_size: lastNameSize,
          // });
        });
      });
    }
  }

  changeModel(model) {
    let $preview = $(`#${this.canvasId}`);
    let $wrapper = $preview.closest('.decor-wrapper');

    $wrapper.removeClass('round key_configurator');

    if(model === 'round') {
      $wrapper.addClass('round');
    }
    if(model === 'key_configurator') {
      $wrapper.addClass('key_configurator');
    }
  }

  addDecorSizes(width, height) {
    let $preview = $(`#${this.canvasId}`);
    let $wrapper = $preview.closest('.decor-wrapper');
    let $x = $wrapper.find('.line-x .size');
    let $y = $wrapper.find('.line-y .size');

    $x.html(`${width} cm`);
    $y.html(`${height} cm`);
  }

  parseTextSettings(payload, type = 'single', key = 0) {
    return {
      color: payload.props.text_color,
      font_size: payload.data.font_size,
      font_family: payload.props.font_family,
      font_weight: payload.data.font_weight,
      max_width: payload.data.text_sizes.width,
      x: type === 'single' ? payload.data.text_coordinates.single.x : payload.data.text_coordinates.multiple[key].x,
      y: type === 'single' ? payload.data.text_coordinates.single.y : payload.data.text_coordinates.multiple[key].y,
      text_uppercase: payload.data.text_uppercase,
      text_direction: payload.data.text_direction,
      model: payload.props.model,
      model_height: payload.data.sizes.height,
    }
  }

  addText(texts, settings, type, textOrder, multiple = false, textLonger) {
    if(settings[0].font_family=="Indie Flower" &&
      (
        texts[0].indexOf('y') !== -1 ||
        texts[0].indexOf('g') !== -1 ||
        texts[0].indexOf('j') !== -1
      )){
      settings[0].y-settings[0].font_size*0.12;
    }
    let font_sizes = [];
    if(texts.length == 2){

      if(settings[1].font_family=="Indie Flower" &&
        (
          texts[1].indexOf('y') !== -1 ||
          texts[1].indexOf('g') !== -1 ||
          texts[1].indexOf('j') !== -1
        )){
        settings[0].y-settings[0].font_size*0.12;
        settings[1].y-settings[1].font_size*0.12;
      }

      if(1){
        let fn={
          fix :false,
          textWidth: this.ctx.measureText(texts[0]).width,
          maxWidth: settings[0].max_width,
          textScale: null,
        };

        // let fix = false;
        // let textWidth = this.ctx.measureText(texts[0]).width;
        // let maxWidth = settings[0].max_width;
        // let textScale = null;
        let isYGJWords = texts[1].indexOf('y') !== -1 || texts[1].indexOf('g') !== -1 || texts[1].indexOf('j') !== -1;
        let isElongated = settings[0].model === 'elongated';
        let isBagLabel = settings[0].model === 'bag_configurator';
        let isKeyLabel = settings[0].model === 'key_configurator';
        let isRound = settings[0].model === 'round';
        let isSmallRectangular = settings[0].model === 'rectangular_small';
        let isRectangular = settings[0].model === 'rectangular';

        if(
          settings[0].model !== 'elongated' &&
          settings[0].font_family=="Indie Flower" &&
          (
            texts[0].indexOf('y') !== -1 ||
            texts[0].indexOf('g') !== -1 ||
            texts[0].indexOf('j') !== -1
          )
        ){
          settings[0].font_size = Math.min(60,settings[0].font_size);

          this.ctx.font = `${settings[0].font_weight} ${settings[0].font_size}px ${settings[0].font_family}`;
          fn.textWidth = this.ctx.measureText(texts[0]).width;
          if(fn.textWidth > fn.maxWidth) {
            fn.textScale = fn.maxWidth/fn.textWidth;
            settings[0].font_size = settings[0].font_size*fn.textScale;
            this.ctx.font = `${settings[0].font_weight} ${settings[0].font_size}px ${settings[0].font_family}`;
          }
          fn.fix = true
        }
        switch (settings[0].font_family) {
          case "Permanent Marker":
            if (isRectangular) {
              settings[0].y = settings[0].y-settings[0].font_size*0.05;
              settings[0].font_size += 6;
              settings[1].font_size += 6;
            }
            if(isSmallRectangular) {
              settings[0].y = settings[0].y-settings[0].font_size*0.04;
            }
            break;
          case "Cocogoose":
            if (isRound) {
              settings[0].y = settings[0].y-settings[0].font_size*0.15;
              settings[1].y = settings[1].y-settings[1].font_size*0.15;
            }
            if (isRectangular) {
              if(isYGJWords) settings[0].font_size = Math.min(73,settings[0].font_size);
              settings[0].y = settings[0].y-settings[0].font_size*0.03;
            }
            if (isSmallRectangular) {
              settings[0].font_size = Math.min(45,settings[0].font_size);
              settings[0].y = settings[0].y-settings[0].font_size*0.08;
            }
            break;
          case "Luckiest Guy":
            if (isRectangular) {
              settings[0].y = settings[0].y-settings[0].font_size*-0.03;
              settings[0].font_size += 6;
              settings[1].font_size += 6;
            }
            break;
          case "Lobster":
            if (isRound) {
              settings[0].font_size -= 3;
              settings[0].y = settings[0].y-settings[0].font_size*0.12;
              settings[1].y = settings[1].y-settings[1].font_size*0.12;
            }
            if (isRectangular) {
              settings[0].font_size = Math.min(75,settings[0].font_size);
              settings[0].y = settings[0].y-settings[0].font_size*0.05;
            }
            if (isSmallRectangular) {
              settings[0].font_size = Math.min(45,settings[0].font_size);
              settings[0].y = settings[0].y-settings[0].font_size*0.05;
            }
            break;
          case "Indie Flower":
            if (isRound) {
              settings[0].font_size -= 6;
              settings[0].y = settings[0].y-settings[0].font_size*0.20;
              settings[1].y = settings[1].y-settings[1].font_size*0.20;
            }
            break;
          case "Alfa Slab One":
            if(isSmallRectangular) {
              settings[0].y = settings[0].y-settings[0].font_size*0.03;
              settings[0].font_size = Math.min(40,settings[0].font_size);
            }
            if (isRectangular) {
              settings[0].font_size = Math.min(75,settings[0].font_size);
            }
            if (isRound) {
              settings[0].font_size -= 4;
              settings[0].y = settings[0].y-settings[0].font_size*0.05;
              settings[1].y = settings[1].y-settings[1].font_size*0.05;
            }
            break;
          case "Fjalla One":
            if(isSmallRectangular) {
              settings[0].font_size = Math.min(40,settings[0].font_size);
              settings[0].y = settings[0].y-settings[0].font_size*0.05;
            }
            if (isRound) {
              settings[0].font_size -= 3;
              settings[0].y = settings[0].y-settings[0].font_size*0.15;
              settings[1].y = settings[1].y-settings[1].font_size*0.15;
            }
            break;
          case "Balsamiq Sans":
            if (isSmallRectangular) {
              settings[0].font_size = Math.min(45,settings[0].font_size);
              settings[0].y = settings[0].y-settings[0].font_size*0.02;
            }
            break;
          default:
            break;
        }
        if(settings[0].text_uppercase) {
          texts[0] = texts[0].toUpperCase();
        }
        if(type === 1 && (settings[0].model == 'rectangular' || settings[0].model == 'rectangular_small')) {
          settings[0].font_size = settings[0].font_size/2;
        }
        this.ctx.font = `${settings[0].font_weight} ${settings[0].font_size}px ${settings[0].font_family}`;
        this.ctx.textAlign = settings[0].text_direction;
        this.ctx.textBaseline = "middle";

        if(window.configurator_first_name && window.configurator_last_name) {
          fn.firstNameWidth = this.ctx.measureText(window.configurator_first_name).width;
          fn.lastNameWidth = this.ctx.measureText(window.configurator_last_name).width;

          if(fn.firstNameWidth > fn.lastNameWidth) {
            fn.textWidth = fn.firstNameWidth;
          }else {
            fn.textWidth = fn.lastNameWidth;
          }

          switch(settings[0].font_family) {
            case 'Cocogoose':
              if(texts[0] === window.configurator_last_name) {
                settings[0].y = settings[0].y + 3;
              }
              break;
          }
        }
        /*
        let metrics = this.ctx.measureText(text);
        let fontHeight = metrics.fontBoundingBoxAscent + metrics.fontBoundingBoxDescent;
        let actualHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
         */
        if(fn.textWidth > fn.maxWidth && !fn.fix) {
          fn.textScale = fn.maxWidth/fn.textWidth;
          settings[0].font_size = settings[0].font_size*fn.textScale;
          this.ctx.font = `${settings[0].font_weight} ${settings[0].font_size}px ${settings[0].font_family}`;
        }

        // if(settings[0].font_family == 'Indie Flower' && ){
        //     this.ctx.font = `${settings[0].font_weight} ${Math.min(60,settings[0].font_size)}px ${settings[0].font_family}`;
        // };

        this.ctx.fillStyle = settings[0].color;
        // if(multiple){
        //     this.ctx.fillText(texts[0], settings[0].x, settings[0].y-(settings[0].font_size/2*(textOrder[0] == 'first'?1:-1))*1.08);
        // } else {
        //     this.ctx.fillText(texts[0], settings[0].x, settings[0].y);
        // }
        font_sizes.push(settings[0].font_size);
      }
      if(2){
        let fn={
          fix :false,
          textWidth: this.ctx.measureText(texts[1]).width,
          maxWidth: settings[1].max_width,
          textScale: null,
        };

        // let fix = false;
        // let textWidth = this.ctx.measureText(texts[1]).width;
        // let maxWidth = settings[1].max_width;
        // let textScale = null;
        let isYGJWords = texts[1].indexOf('y') !== -1 || texts[1].indexOf('g') !== -1 || texts[1].indexOf('j') !== -1;
        let isElongated = settings[0].model === 'elongated';
        let isRound = settings[0].model === 'round';
        let isBagLabel = settings[0].model === 'bag_configurator';
        let isKeyLabel = settings[0].model === 'key_configurator';
        let isSmallRectangular = settings[0].model === 'rectangular_small';
        let isRectangular = settings[0].model === 'rectangular';
        if(
          settings[1].model !== 'elongated' &&
          settings[1].font_family=="Indie Flower" &&
          (
            texts[1].indexOf('y') !== -1 ||
            texts[1].indexOf('g') !== -1 ||
            texts[1].indexOf('j') !== -1
          )
        ){
          settings[1].font_size = Math.min(60,settings[1].font_size);

          this.ctx.font = `${settings[1].font_weight} ${settings[1].font_size}px ${settings[1].font_family}`;
          fn.textWidth = this.ctx.measureText(texts[1]).width;
          if(fn.textWidth > fn.maxWidth) {
            fn.textScale = fn.maxWidth/fn.textWidth;
            settings[1].font_size = settings[1].font_size*fn.textScale;
            this.ctx.font = `${settings[1].font_weight} ${settings[1].font_size}px ${settings[1].font_family}`;
          }
          fn.fix = true
        }

        switch (settings[1].font_family) {
          case "Indie Flower":
            if(isYGJWords) settings[1].y = settings[1].y-settings[1].font_size*-0.15;
            break;
          case "Fjalla One":
            if (isRound){
              settings[1].y = settings[1].y-settings[1].font_size*-0.12;
              break;
            }
            if(isSmallRectangular) {
              settings[1].font_size = Math.min(40,settings[1].font_size);
              settings[1].y = settings[1].y-settings[1].font_size*-0.05;
              break;
            }
            if(isYGJWords) settings[1].font_size = Math.min(73,settings[1].font_size);
            settings[1].y = settings[1].y-settings[1].font_size*-0.05;
            break;
          case "Alfa Slab One":
            if(isSmallRectangular) {
              settings[1].y = settings[1].y-settings[1].font_size*-0.03;
              settings[1].font_size = Math.min(40,settings[1].font_size);
            }
            if (isRectangular) {
              settings[1].y = settings[1].y-settings[1].font_size*(isYGJWords ? 0.05 : 0.00);
            }
            break;
          case "Permanent Marker":
            if (isRectangular) {
              settings[1].y = settings[1].y-settings[1].font_size*0.06;
            }
            if(isSmallRectangular) {
              settings[1].y = settings[1].y-settings[1].font_size*0.07;
            }
            break;
          case "Cocogoose":
            if (isRectangular) {
              if(isYGJWords) settings[1].font_size = Math.min(73,settings[1].font_size);
              settings[1].y = settings[1].y-settings[1].font_size*(isYGJWords ? 0.03 : 0.00);
            }
            if (isSmallRectangular) {
              settings[1].font_size = Math.min(45,settings[1].font_size);
              settings[1].y = settings[1].y-settings[1].font_size*(isYGJWords ? 0.10 : 0.08);
            }
            break;
          case "Lobster":
            if (isRectangular) {
              settings[1].font_size = Math.min(75,settings[1].font_size);
              settings[1].y = settings[1].y-settings[1].font_size*0.05;
            }
            if (isSmallRectangular) {
              settings[1].font_size = Math.min(45,settings[1].font_size);
              settings[1].y = settings[1].y-settings[1].font_size*0.05;
            }
            break;
          case "Balsamiq Sans":
            if (isSmallRectangular) {
              settings[1].font_size = Math.min(45,settings[1].font_size);
              settings[1].y = settings[1].y-settings[1].font_size*0.02;
            }
            break;
          default:
            break;
        }
        if(settings[1].text_uppercase) {
          texts[1] = texts[1].toUpperCase();
        }
        if(type === 1 && (settings[1].model == 'rectangular' || settings[1].model == 'rectangular_small')) {
          settings[1].font_size = settings[1].font_size/2;
        }
        this.ctx.font = `${settings[1].font_weight} ${settings[1].font_size}px ${settings[1].font_family}`;
        this.ctx.textAlign = settings[1].text_direction;
        this.ctx.textBaseline = "middle";

        if(window.configurator_first_name && window.configurator_last_name) {
          fn.firstNameWidth = this.ctx.measureText(window.configurator_first_name).width;
          fn.lastNameWidth = this.ctx.measureText(window.configurator_last_name).width;

          if(fn.firstNameWidth > fn.lastNameWidth) {
            fn.textWidth = fn.firstNameWidth;
          }else {
            fn.textWidth = fn.lastNameWidth;
          }

          switch(settings[1].font_family) {
            case 'Cocogoose':
              if(texts[1] === window.configurator_last_name) {
                settings[1].y = settings[1].y + 3;
              }
              break;
          }
        }
        /*
        let metrics = this.ctx.measureText(text);
        let fontHeight = metrics.fontBoundingBoxAscent + metrics.fontBoundingBoxDescent;
        let actualHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
         */
        if(fn.textWidth > fn.maxWidth && !fn.fix) {
          fn.textScale = fn.maxWidth/fn.textWidth;
          settings[1].font_size = settings[1].font_size*fn.textScale;
          this.ctx.font = `${settings[1].font_weight} ${settings[1].font_size}px ${settings[1].font_family}`;
        }

        // if(settings[1].font_family == 'Indie Flower' && ){
        //     this.ctx.font = `${settings[1].font_weight} ${Math.min(60,settings[1].font_size)}px ${settings[1].font_family}`;
        // };

        this.ctx.fillStyle = settings[1].color;

        let minFontSize = Math.min(settings[0].font_size,settings[1].font_size);
        this.ctx.font = `${settings[0].font_weight} ${minFontSize}px ${settings[0].font_family}`;
        this.ctx.font = `${settings[1].font_weight} ${minFontSize}px ${settings[1].font_family}`;

        this.ctx.fillText(texts[0], settings[0].x, settings[0].y-(settings[0].font_size/2*(textOrder[0] == 'first'?1:-1))*1.08);
        this.ctx.fillText(texts[1], settings[1].x, settings[1].y-(settings[1].font_size/2*(textOrder[1] == 'first'?1:-1))*1.08);
        font_sizes.push(settings[1].font_size);

      }
      return font_sizes;
    }
    else {
      let fix = false;
      let isYGJWords = texts[0].indexOf('y') !== -1 || texts[0].indexOf('g') !== -1 || texts[0].indexOf('j') !== -1;
      let isElongated = settings[0].model === 'elongated';
      let isRound = settings[0].model === 'round';
      let isBagLabel = settings[0].model === 'bag_configurator';
      let isKeyLabel = settings[0].model === 'key_configurator';
      let isSmallRectangular = settings[0].model === 'rectangular_small';
      let isRectangular = settings[0].model === 'rectangular';
      let textWidth = this.ctx.measureText(texts[0]).width;
      let maxWidth = settings[0].max_width;
      let textScale = null;

      if(
        settings[0].model !== 'elongated' &&
        settings[0].font_family == "Indie Flower" &&
        (
          texts[0].indexOf('y') !== -1 ||
          texts[0].indexOf('g') !== -1 ||
          texts[0].indexOf('j') !== -1
        )
      ){
        settings[0].font_size = Math.min(60,settings[0].font_size);
        if (settings[0].model == 'rectangular_small'){
          settings[0].font_size = Math.min(40,settings[0].font_size);
        }
        settings[0].y = settings[0].y-settings[0].font_size*0.15;

        this.ctx.font = `${settings[0].font_weight} ${settings[0].font_size}px ${settings[0].font_family}`;
        textWidth = this.ctx.measureText(texts[0]).width;
        if(textWidth > maxWidth) {
          textScale = maxWidth/textWidth;
          settings[0].font_size = settings[0].font_size*textScale;
          this.ctx.font = `${settings[0].font_weight} ${settings[0].font_size}px ${settings[0].font_family}`;
        }
        fix = true
      }

      switch (settings[0].font_family) {
        case "Indie Flower":
          if(isRound){
            settings[0].font_size += 13;
          }
          if(isElongated) {
            settings[0].y = settings[0].y-settings[0].font_size*(isYGJWords ? 0.16 : 0.00);
          }
          if(isBagLabel){
            settings[0].font_size = settings[0].font_size * 2 - 30;
          }
          if(isKeyLabel){
            settings[0].font_size = settings[0].font_size * 2 - 22;
          }
          break;
        case "Permanent Marker":
          if(isRound){
            settings[0].font_size += 27;
          }
          if(isBagLabel){
            settings[0].font_size = settings[0].font_size * 2 - 8;
          }
          if(isKeyLabel){
            settings[0].font_size = settings[0].font_size * 2 - 2;
          }
          settings[0].y = settings[0].y-settings[0].font_size*0.15;
          break;
        case "Fjalla One":
          if(isRound){
            settings[0].font_size += 30;
          }
          if (isRectangular || isElongated || isRound) {
            settings[0].font_size = Math.min(75,settings[0].font_size);
            settings[0].y = settings[0].y-settings[0].font_size*(isYGJWords ? 0.05 : -0.02);
          }
          if(isBagLabel){
            settings[0].font_size = settings[0].font_size * 2 - 21;
          }
          if(isKeyLabel){
            settings[0].font_size = settings[0].font_size * 2 - 14;
          }
          if(isSmallRectangular){
            settings[0].font_size = Math.min(40,settings[0].font_size);
            settings[0].y = settings[0].y-settings[0].font_size*(isYGJWords ? 0.12 : 0.05);
          }
          if(isElongated){
            settings[0].y = settings[0].y-settings[0].font_size*(isYGJWords ? 0.08 : 0.00);
          }
          break;
        case "Lobster":
          if(isRound){
            settings[0].font_size += 28;
          }
          if(isBagLabel){
            settings[0].font_size = settings[0].font_size * 2 - 22;
          }
          if(isKeyLabel){
            settings[0].font_size = settings[0].font_size * 2 - 13;
          }
          if(isElongated) {
            settings[0].y = settings[0].y-settings[0].font_size*0.05;
          }
          if (isRectangular || isElongated || isRound) {
            settings[0].y = settings[0].y-settings[0].font_size*(isYGJWords ? 0.12 : 0.05);
          }
          if(isSmallRectangular) {
            settings[0].font_size = Math.min(40,settings[0].font_size);
            settings[0].y = settings[0].y-settings[0].font_size*(isYGJWords ? 0.20 : 0.10);
          }
          break;
        case "Balsamiq Sans":
          if(isRound){
            settings[0].font_size += 28;
          }
          if(isBagLabel){
            settings[0].font_size = settings[0].font_size * 2 + 4;
          }
          if(isKeyLabel){
            settings[0].font_size *= 2;
          }
          settings[0].y = settings[0].y-settings[0].font_size*0.04;
          break;
        case "Cocogoose":
          if(isRound){
            settings[0].font_size += 26;
          }
          if(isElongated) {
            settings[0].y = settings[0].y-settings[0].font_size*0.10;
            break;
          }
          if(isBagLabel){
            settings[0].font_size = settings[0].font_size * 2 + 40;
          }
          if(isKeyLabel){
            settings[0].font_size *= 2;
          }
          settings[0].font_size = Math.min(75,settings[0].font_size);
          settings[0].y = settings[0].y-settings[0].font_size*0.10;
          break;
        case "Alfa Slab One":
          if(isRound){
            settings[0].font_size += 20;
          }
          if(isBagLabel){
            settings[0].font_size = settings[0].font_size * 3;
          }
          if(isKeyLabel){
            settings[0].font_size = settings[0].font_size * 3;
          }
          if (isRectangular) {
            settings[0].y = settings[0].y-settings[0].font_size*0.00;
            break;
          }
          settings[0].y = settings[0].y-settings[0].font_size*(isElongated ? (isYGJWords ? 0.07 : 0.04) : 0.05);
          break;
        case "Luckiest Guy":
          if(isRound){
            settings[0].font_size += 34;
          }
          if(isBagLabel){
            settings[0].font_size = settings[0].font_size * 2 + 3;
          }
          if(isKeyLabel){
            settings[0].font_size = settings[0].font_size * 2 + 8;
          }
          break;
        default:
          break;
      }


      if(settings[0].text_uppercase) {
        texts[0] = texts[0].toUpperCase();
      }
      if(type === 1 && (settings[0].model == 'rectangular' || settings[0].model == 'rectangular_small')) {
        settings[0].font_size = settings[0].font_size/2;
      }
      this.ctx.font = `${settings[0].font_weight} ${settings[0].font_size}px ${settings[0].font_family}`;
      this.ctx.textAlign = settings[0].text_direction;
      this.ctx.textBaseline = "middle";

      if(window.configurator_first_name && window.configurator_last_name) {
        let firstNameWidth = this.ctx.measureText(window.configurator_first_name).width;
        let lastNameWidth = this.ctx.measureText(window.configurator_last_name).width;

        if(firstNameWidth > lastNameWidth) {
          textWidth = firstNameWidth;
        }else {
          textWidth = lastNameWidth;
        }

        // switch(settings[0].font_family) {
        //     case 'Cocogoose':
        //         if(texts[0] === window.configurator_last_name) {
        //             settings[0].y = settings[0].y + 3;
        //         }
        //         break;
        // }
      }else{
        let firstNameWidth = this.ctx.measureText(texts[0]).width;
        textWidth = firstNameWidth;
      }
      /*
      let metrics = this.ctx.measureText(text);
      let fontHeight = metrics.fontBoundingBoxAscent + metrics.fontBoundingBoxDescent;
      let actualHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
       */
      if(textWidth > maxWidth && !fix) {
        textScale = maxWidth/textWidth;

        if(settings[0].font_family === 'Alfa Slab One' && isBagLabel){
          settings[0].font_size = settings[0].font_size*textScale + 4;
        } else if (settings[0].font_family === 'Alfa Slab One' && isKeyLabel){
          settings[0].font_size = settings[0].font_size*textScale + 4;
        } else if (settings[0].font_family === 'Cocogoose' && isBagLabel){
          settings[0].font_size = settings[0].font_size*textScale + 4;
        } else {
          settings[0].font_size = settings[0].font_size*textScale;
        }
        this.ctx.font = `${settings[0].font_weight} ${settings[0].font_size}px ${settings[0].font_family}`;
      }

      // if(settings[0].font_family == 'Indie Flower' && ){
      //     this.ctx.font = `${settings[0].font_weight} ${Math.min(60,settings[0].font_size)}px ${settings[0].font_family}`;
      // };

      this.ctx.fillStyle = settings[0].color;

      this.ctx.fillText(texts[0], settings[0].x, settings[0].y);
      return settings[0].font_size;
    }
  }

  addImage(url, sizes, coordinates, border) {
    return new Promise((resolve, reject) => {
      resolve();
      // let img = new Image();
      //
      // img.crossOrigin = 'Anonymous';
      // img.src = url;
      // img.onload = () => {
      //   img = this.prepareImageBySize(img, sizes);
      //
      //   if(border) {
      //     this.ctx.beginPath();
      //     this.ctx.fillStyle = border;
      //     this.ctx.fillRect((coordinates.x - (img.width / 2)) - 1, (coordinates.y - (img.height / 2)) - 1, img.width + 2, img.height + 2);
      //     this.ctx.closePath();
      //     this.ctx.stroke();
      //   }
      //
      //   this.ctx.drawImage(img, coordinates.x - (img.width / 2), coordinates.y - (img.height / 2), img.width, img.height);
      //   resolve();
      // }
    });
  }

  prepareImageBySize(img, sizes) {
    let imageScale = img.width / img.height;
    let imagePlaceScale = sizes.width / sizes.height;
    let width = img.width;
    let height = img.height;

    if(img.width >= sizes.width && img.height >= sizes.height) {
      if(imageScale === imagePlaceScale) {
        width = sizes.width;
        height = sizes.height;
      }else {
        let result = this.imageHelper.getClosestImageSize(img, sizes);

        width = result.getWidth();
        height = result.getHeight();
      }
    }else {
      if(imageScale !== imagePlaceScale) {
        if((img.width >= sizes.width && img.height < sizes.height) || (img.width < sizes.width && img.height >= sizes.height)) {
          let result = this.imageHelper.getClosestImageSize(img, sizes);

          width = result.getWidth();
          height = result.getHeight();
        }
      }
    }

    img.width = width;
    img.height = height;

    return img;
  }

  addBg(data, width, height) {
    return new Promise((resolve, reject) => {

      resolve();
      // if(data.includes('http')) {
      //   let img = new Image();
      //
      //   img.crossOrigin = 'Anonymous';
      //   // img.src = data;
      //   img.onload = () => {
      //     this.ctx.fillStyle = this.ctx.createPattern(img, 'repeat');
      //     if(this.isBagLabel){
      //       this.ctx.fill(this.bagLabelFormPath[this.stickerLabelType]);
      //     }else{
      //       this.ctx.fillRect(0, 0, width, height);
      //     }
      //     resolve();
      //   };
      // }else {
      //   if(this.isBagLabel){
      //     this.ctx.beginPath();
      //     this.ctx.fillStyle = data;
      //     this.ctx.fill(this.bagLabelFormPath[this.stickerLabelType]);
      //     this.ctx.strokeStyle = '#E6E6E6';
      //     this.ctx.stroke(this.bagLabelFormPath[this.stickerLabelType])
      //   } else {
      //     this.ctx.fillStyle = data;
      //     this.ctx.fillRect(0, 0, width, height);
      //   }
      //   resolve();
      // }
    });
  }

  getBase64() {
    return this.canvas.toDataURL('image/png');
  }
}
